if (!customElements.get('bs-season-nav')) {
  class BsSeasonNav extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bs-season-nav__track');
      this.items = Array.from(this.track.querySelectorAll('.bs-season-nav__item'));
      this.prev = this.querySelector('.bs-season-nav__arrow--prev');
      this.next = this.querySelector('.bs-season-nav__arrow--next');

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.initDrag();

      // Start with the current season in view (set scrollLeft directly so the page itself doesn't scroll)
      const current = this.track.querySelector('.is-current');
      if (current) {
        const overflow = current.offsetLeft + current.offsetWidth - this.track.clientWidth;
        if (overflow > 0) this.track.scrollLeft = current.offsetLeft;
      }

      this.update();
    }

    // Click-and-drag with a mouse (touch and trackpads already scroll natively)
    initDrag() {
      let startX = 0;
      let startScroll = 0;
      let dragging = false;
      let moved = false;

      // Stop the browser's own link/image dragging from taking over
      this.track.addEventListener('dragstart', (event) => event.preventDefault());

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = this.track.scrollLeft;
      });

      this.track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (!moved && Math.abs(distance) < 5) return;
        if (!moved) {
          moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
        }
        this.track.scrollLeft = startScroll - distance;
      });

      const end = () => {
        if (!dragging) return;
        dragging = false;
        this.classList.remove('is-dragging');
      };
      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);

      // A drag shouldn't also count as clicking the season it ended on
      this.track.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        },
        true
      );
    }

    // Moves along by one season, lining the next/previous item up with the left edge
    step(direction) {
      const left = this.track.scrollLeft;
      let target;

      if (direction > 0) {
        target = this.items.find((item) => item.offsetLeft > left + 1);
      } else {
        target = this.items.filter((item) => item.offsetLeft < left - 1).pop();
      }

      this.track.scrollTo({ left: target ? target.offsetLeft : direction > 0 ? this.track.scrollWidth : 0, behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
      this.classList.toggle('is-scrollable', max > 1);
      this.classList.toggle('is-at-start', this.track.scrollLeft <= 1);
      this.classList.toggle('is-at-end', this.track.scrollLeft >= max - 1);
    }
  }

  customElements.define('bs-season-nav', BsSeasonNav);
}
